import Joi from 'joi';

export const offerSchema = (t) =>
  Joi.object({
    offerName: Joi.string().label(t('offer_name')).required(),
    vendorServiceCategoryIds: Joi.array()
      .label(t('service_category'))
      .required(),
    vendorServiceId: Joi.number().label(t('service_name')).required(),
    offerStartDate: Joi.date().label(t('start_date')).required(),
    offerEndDate: Joi.date()
      .label(t('end_date'))
      .when('offerWithDuration', {
        is: true,
        then: Joi.required(),
        otherwise: Joi.allow(null),
      }),
    offerWithDuration: Joi.boolean(),
    withPSICommission: Joi.boolean(),
    psiCommissionPercentage: Joi.number()
      .min(0)
      .max(100)
      .label(t('psi_commission'))
      .when('withPSICommission', {
        is: true,
        then: Joi.required(),
        otherwise: Joi.allow(null),
      }),
    promoCode: Joi.string().label(t('promo_code')).required(),
    offerStatusId: Joi.number().label(t('offer_status')).required(),
    vendorServiceCategoryIds: Joi.array()
      .label(t('service_category'))
      .min(1)
      .required(),
    offerAvailableOn: Joi.number().label(t('offer_availability')).required(),
    vendorServiceId: Joi.number().label(t('service_name')).required(),
    discountPercentage: Joi.number()
      .min(0)
      .max(100)
      .label(t('discount'))
      .required(),
  }).options({ allowUnknown: true, abortEarly: false });
